export default __webpack_public_path__ + "static/media/c.e580cb17.svg";